import { render, staticRenderFns } from "./NavigationPanelsContainer.vue?vue&type=template&id=0d50c606&"
import script from "./NavigationPanelsContainer.vue?vue&type=script&lang=js&"
export * from "./NavigationPanelsContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports